import { LegalPageLayout } from './LegalPageLayout';

export function CookiePolicyPage() {
  return (
    <LegalPageLayout title="Cookie Policy">
      <p className="mt-2 text-sm text-neutral-500">
                    Sezione B
                  </p>
      
                  <div className="mt-6 rounded-lg bg-neutral-100 p-6 text-sm text-neutral-700">
                    <p>
                      <strong>Titolare:</strong> Klaro7 S.r.l.s., Via Prospero 5/b, 10095 Grugliasco (TO), P.I. 13344040012
                    </p>
                    <p className="mt-1">
                      <strong>Email privacy:</strong>{' '}
                      <a href="mailto:privacy@klaro7.it" className="text-teal-700 underline">
                        privacy@klaro7.it
                      </a>
                    </p>
                    <p className="mt-1">
                      <strong>Data Ultima Revisione:</strong> 07 Maggio 2026
                    </p>
                  </div>
      
                  
                    {/* ---- 7. COSA SONO I COOKIE E TIPOLOGIE UTILIZZATE ---- */}
                    <h2>7. Cosa Sono i Cookie e Tipologie Utilizzate</h2>
                    <p>
                      I cookie sono piccoli file di testo che i siti web salvano sul dispositivo
                      dell&apos;utente durante la navigazione. Vengono utilizzati per diverse
                      finalità tecniche, statistiche e di personalizzazione.
                    </p>
      
                    <h3>Cookie Tecnici (Necessari)</h3>
                    <p>
                      Sono indispensabili per il corretto funzionamento del sito: autenticazione,
                      gestione del carrello, sicurezza. <strong>Non richiedono consenso.</strong>
                    </p>
      
                    <h3>Cookie Analitici (Anonimizzati)</h3>
                    <p>
                      Vengono utilizzati per raccogliere statistiche aggregate, monitorare le
                      performance e migliorare il sito. Sono considerati assimilabili ai cookie
                      tecnici se anonimizzati.
                    </p>
      
                    <h3>Cookie di Profilazione e di Terze Parti (Previa Accettazione)</h3>
                    <p>
                      Consentono la personalizzazione dei contenuti e della pubblicità in base al
                      comportamento di navigazione dell&apos;utente.{' '}
                      <strong>Richiedono il consenso esplicito dell&apos;utente</strong> e vengono
                      attivati solo dopo l&apos;accettazione tramite il banner o il pannello
                      &laquo;Preferenze cookie&raquo;.
                    </p>
                    <p>
                      In questa categoria rientra <strong>Google Analytics 4</strong> (fornitore:
                      Google Ireland Ltd.), utilizzato per analizzare l&apos;uso del sito. Installa
                      cookie come <code>_ga</code> e <code>_ga_*</code> (durata fino a 24 mesi) e può
                      comportare il trasferimento di dati verso Paesi extra&nbsp;UE. Il consenso non
                      è preimpostato: senza accettazione esplicita Google Analytics non viene
                      caricato.
                    </p>
      
                    {/* ---- 8. GESTIONE DEI CONSENSI E DURATA ---- */}
                    <h2>8. Gestione dei Consensi e Durata</h2>
                    <p>L&apos;utente può gestire le proprie preferenze sui cookie tramite:</p>
                    <ul>
                      <li>
                        <strong>Banner Iniziale:</strong> accettando o rifiutando le singole
                        categorie di cookie al primo accesso al sito.
                      </li>
                      <li>
                        <strong>Pannello &laquo;Preferenze cookie&raquo;:</strong> tramite
                        l&apos;apposito pulsante sempre disponibile sul sito, per modificare o
                        revocare il consenso in qualsiasi momento.
                      </li>
                      <li>
                        <strong>Impostazioni del Browser:</strong> modificando le impostazioni del
                        proprio browser per bloccare o eliminare i cookie.
                      </li>
                    </ul>
                    <p>
                      Il consenso alla profilazione è facoltativo e revocabile in qualsiasi momento.
                    </p>
      
                    {/* ---- DISPOSIZIONI FINALI ---- */}
                    <h2>Disposizioni Finali</h2>
                    <p>
                      Klaro7 può aggiornare la presente Cookie Policy in qualsiasi momento. Gli
                      utenti saranno informati tramite email o banner sulla piattaforma.
                    </p>
                    <p>
                      <strong>Foro Competente:</strong> Foro di Torino.
                    </p>
      
                    <hr className="my-8" />
      
                    <p className="text-sm text-neutral-500">
                      Consulta anche la nostra{' '}
                      <a href="/privacy" className="text-teal-700 underline">
                        Informativa Privacy
                      </a>
                      .
                    </p>
    </LegalPageLayout>
  );
}
